import * as Yup from 'yup'
import { BUDGET } from '../../../../Tiktok/CampaignForms/CampaignTikTokEdit/fields'
import { formatNumber } from '../../../../../helpers/numbers'

export const getBudgetValidation = ({ remainingBudget, initialBudget }) => {
  if (remainingBudget || remainingBudget === 0) {
    // In edit form we need to sum: remainingBudget + initialBudget, to represent the max value user can enter
    const maxBudget = initialBudget ? remainingBudget + initialBudget : remainingBudget

    return Yup.object({
      [BUDGET]: Yup.number()
        .required('Budget is required')
        .max(maxBudget, `Must be less than or equal to ${formatNumber(maxBudget, { max: 2 })}`)
    })
  } else {
    return Yup.object({
      [BUDGET]: Yup.number().required('Budget is required')
    })
  }
}
